import { render, staticRenderFns } from "./BotModal.vue?vue&type=template&id=3213476f&"
import script from "./BotModal.vue?vue&type=script&lang=js&"
export * from "./BotModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports